// AgeScreen.jsx -- onboarding step `age` (canvas 2 + 2b). Single job: collect a real date and have the
// user confirm it. Never shows the cutoff; never stores the date; onConfirm gets {y,m,d} once.
import { useState, useRef } from 'react';
import { shell, headline, eyebrow, body, primaryBtn, disabledBtn, ghostBtn, spacer, StepBar, C } from './onboardingStyles';
import { isRealDate, todayLocal, yearRange, formatDob } from './age';

const MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
const field = { height: 52, borderRadius: 8, border: `1px solid ${C.border}`, background: C.input, color: C.primary, font: 'inherit', fontSize: 16, padding: '0 12px' };
const lbl = { display: 'flex', flexDirection: 'column', gap: 6, ...eyebrow };

export default function AgeScreen({ onConfirm }) {
  const [m, setM] = useState('');
  const [d, setD] = useState('');
  const [y, setY] = useState('');
  const [confirming, setConfirming] = useState(false);
  const sent = useRef(false);
  const { min, max } = yearRange(todayLocal());
  const dob = { y: Number(y), m: Number(m), d: Number(d) };
  const filled = m !== '' && d !== '' && y !== '';
  const valid = filled && isRealDate(dob);
  const years = []; for (let v = max; v >= min; v -= 1) years.push(v);

  if (confirming) {
    return (
      <div style={shell}>
        <StepBar step={1} />
        <div style={{ marginTop: 40, display: 'flex', flexDirection: 'column', gap: 10 }}>
          <div style={eyebrow}>STEP 1 OF 3</div>
          <h1 style={headline}>Is that right?</h1>
        </div>
        <div style={{ marginTop: 32, background: C.card, border: `1px solid ${C.border}`, borderRadius: 12, padding: 20 }}>
          <div style={eyebrow}>YOU ENTERED</div>
          <div style={{ marginTop: 6, fontSize: 30, fontWeight: 800, letterSpacing: '-0.3px' }}>{formatDob(dob)}</div>
        </div>
        <p style={{ ...body, marginTop: 16, fontSize: 13 }}>Check the year: the wheel is easy to over-scroll.</p>
        <div style={spacer} />
        <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
          <button type="button" style={primaryBtn} onClick={() => { if (sent.current) return; sent.current = true; onConfirm(dob); }}>Yes, that's right</button>
          <button type="button" style={ghostBtn} onClick={() => setConfirming(false)}>Change it</button>
        </div>
      </div>
    );
  }
  return (
    <div style={shell}>
      <StepBar step={1} />
      <div style={{ marginTop: 40, display: 'flex', flexDirection: 'column', gap: 10 }}>
        <div style={eyebrow}>STEP 1 OF 3</div>
        <h1 style={headline}>When were you born?</h1>
      </div>
      <div style={{ marginTop: 32, display: 'grid', gridTemplateColumns: '1.6fr 1fr 1.2fr', gap: 8 }}>
        <label style={lbl}>MONTH
          <select aria-label="Month" style={field} value={m} onChange={(e) => setM(e.target.value)}>
            <option value="">Month</option>
            {MONTHS.map((name, i) => <option key={name} value={i + 1}>{name}</option>)}
          </select>
        </label>
        <label style={lbl}>DAY
          <select aria-label="Day" style={field} value={d} onChange={(e) => setD(e.target.value)}>
            <option value="">Day</option>
            {Array.from({ length: 31 }, (_, i) => <option key={i + 1} value={i + 1}>{i + 1}</option>)}
          </select>
        </label>
        <label style={lbl}>YEAR
          <select aria-label="Year" style={field} value={y} onChange={(e) => setY(e.target.value)}>
            <option value="">Year</option>
            {years.map((v) => <option key={v} value={v}>{v}</option>)}
          </select>
        </label>
      </div>
      <p style={{ ...body, marginTop: 16, fontSize: 13 }}>We use this once to confirm you can use SlipTrack. We keep the result, never your birth date.</p>
      {filled && !valid && <p role="alert" style={{ ...body, marginTop: 8, fontSize: 13, color: '#fbbf24' }}>That date doesn't exist. Check the day.</p>}
      <div style={spacer} />
      <button type="button" disabled={!valid} style={valid ? primaryBtn : disabledBtn} onClick={() => setConfirming(true)}>Continue</button>
    </div>
  );
}
